<template>
   <div class="order_list" v-loading.fullscreen.lock="loading">
      <headerTab :tabList="tabList" @tabChange="tabChange" :selectTabId="tabId"></headerTab>
      <div v-if="orderList.length > 0">
          <div class="order_list_item" v-for="item in orderList" :key="item.uuid" @click="goDetails(item)">
              <div class="order_list_item_header">
                  <div>{{item.order_code}}</div>
                  <div>下单时间：{{item.create_time}}</div>
              </div>
              <div class="order_list_item_content">
                  <div class="order_list_item_content_left">
                      <div class="order_list_item_content_left_city">
                          {{item.start_city}}
                      </div>
                      <div class="order_list_item_content_left_title">
                          <img src="../../assets/order/order_jiantou.png" alt="">
                          <div>
                              <span v-if="item.status == 0">{{item.delivery_type == 1 ? '竞价中' : '待接单' }}</span>
                              <span v-else>{{type[item.status]}}</span>
                            </div>
                      </div>
                      <div class="order_list_item_content_left_city" style="margin-left:24px">
                          {{item.end_city}}
                      </div>
                  </div>
                  <div class="order_list_item_content_right">
                        <el-button v-if="item.status == 0 && item.delivery_type != 1" type="primary" @click="selectDriver(item)">司机列表</el-button>
                        <div v-for="(cItem,index) in btnList[item.status]" :key="index" style="margin-left:18px;">
                            <el-button @click.stop="btnClick(item,cItem.clickName)" v-if="!(cItem.btnName == '处理结果' && item.is_exceptional_deal == 0)" :type="cItem.type">
                                <span>{{cItem.btnName}}</span>
                            </el-button>
                        </div>

                      <!-- <el-button type="primary" @click.stop="selectDriver">司机列表</el-button>
                      <el-button type="primary" v-if="false">电子存单</el-button>
                      <el-button type="primary" v-if="false">处理结果</el-button>
                      <el-button  v-if="false">物流跟踪</el-button>
                      <el-button  @click.stop="getPhone">联系司机</el-button>
                      <el-button @click.stop="getCustomerPhone">联系客服</el-button> -->
                  </div>
              </div>
          </div>
      </div>

        <div class="null" v-if="orderList.length == 0">
            <img src="../../assets/null.png" class="null_img" alt="">
            <div class="null_title">暂无订单</div>
        </div>
      <div class="common_pagination" v-if="total != 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :pager-count="9"
                @current-change="handleCurrentChange"
                :current-page="pageNumber"
                :page-size="pageSize"
                :total="total">
            </el-pagination>
            <div class="common_pagination_right">
                <div class="common_pagination_right_num"><span>{{pageNumber}}</span>/{{lastPage}}</div>
                <div class="common_pagination_right_input">
                    到第
                    <el-input v-model="pageNumberInput" size="small" style="width:63px"></el-input>
                    页
                </div>
                <div class="common_pagination_right_btn">
                    <el-button size="small" @click="changeNumberInput">确定</el-button>
                </div>
            </div>
        </div>
        <driverModal v-if="driverVisible" :driverVisible.sync="driverVisible" :item="selectItem"></driverModal>
        <phoneModal v-if="phoneVisible" :phoneVisible.sync="phoneVisible" :selectItem="phoneItem"></phoneModal>
        <abnormalResult v-if="abnormalResultVisible" :abnormalResultVisible.sync="abnormalResultVisible" :details="abnormalResultData"></abnormalResult>
        <mapTrack v-if="mapTrackVisible" :mapTrackVisible.sync="mapTrackVisible" :addressData="addressData"></mapTrack>
       <transitEntry ref="transitEntryRef"></transitEntry>
   </div>
</template>

<script>
import headerTab from '../../components/header_tab'
import driverModal from './components/driverModal'
import phoneModal from './components/phoneModal'
import transitEntry from './components/transitEntry'
import mapTrack from '../orderDetails/components/mapTrack'

import abnormalResult from '../orderDetails/components/abnormalResult'
export default {
   data (){
       return {
           tabList:[
               {name:'全部订单',id:-1},
               {name:'待接单',id:0},
               {name:'运输中',id:2},
               {name:'待支付',id:3}
           ],
           type:{
               0:'待接单',
               1:'待取货',
               2:'运输中',
               3:'待支付',
               4:'已完成',
               5:'已取消',
               6:'异常'
           },
           num:1,
           btnList:{
               0:[
                //    {btnName:'司机列表',type:'primary',clickName:'selectDriver'},
                   {btnName:'联系客服',type:'',clickName:'getCustomerPhone'},
               ],
               1:[
                //    {btnName:'确认收货',type:'primary',clickName:'confirmReceipt'},
                   {btnName:'联系司机',type:'',clickName:'getPhone'},
                   {btnName:'联系客服',type:'',clickName:'getCustomerPhone'}
               ],
               2:[
                   {btnName:'物流跟踪',type:'primary',clickName:'logisticsTrack'},
                    {btnName:'中转录入',type:'primary',clickName:'transitEntryfun'},
                   {btnName:'联系司机',type:'',clickName:'getPhone'},
                   {btnName:'联系客服',type:'',clickName:'getCustomerPhone'},
               ],
               3:[
                   {btnName:'联系司机',type:'',clickName:'getPhone'},
                   {btnName:'联系客服',type:'',clickName:'getCustomerPhone'},
               ],
               4:[
                //    {btnName:'电子存单',type:'primary',clickName:'depositReceipt'},
                   {btnName:'联系客服',type:'',clickName:'getCustomerPhone'},
               ],
               5:[
                //    {btnName:'电子存单',type:'primary',clickName:'depositReceipt'},
                   {btnName:'联系客服',type:'',clickName:'getCustomerPhone'}
               ],
               6:[
                   {btnName:'处理结果',type:'primary',clickName:'resultsTreatment'},
                   {btnName:'联系客服',type:'',clickName:'getCustomerPhone'}
               ]
           },
           driverVisible:false,
           phoneVisible:false,
           selectItem:{

           },
           orderList:[],
           time:'1611293492000',
           phoneItem:{

           },
           tabId:-1,
           loading:false,

           pageNumber:1,
           total:0,
           lastPage:0,
           pageSize:10,
           pageNumberInput:1,
           abnormalResultData:{},
           abnormalResultVisible:false,
           addressData:{},
           mapTrackVisible:false

       }
   },
   components: {
       headerTab,
       driverModal,
       phoneModal,
       abnormalResult,
       mapTrack,
       transitEntry
   },
   watch: {

   },
   computed: {

   },
   methods: {
     transitEntryfun(item){
  
       this.$refs.transitEntryRef.open(item.uuid)
     },
    //    btn的转发
       btnClick(item,clickName){
           this[clickName](item);
       },
        //    电子存单
        depositReceipt(item){

        },
        // 确认收货
        confirmReceipt(item){
            this.loading = true;
            this.$post('OrderConfirmTake',{id:item.uuid})
                .then(data => {
                    this.loading = false;
                    this.$message.success('操作成功!');
                    this.getOrderList();
                } , error =>{
                    this.loading = false;
                    this.$message.error(error)
                });
        },
        // 物流跟踪
        logisticsTrack(item){
            this.loading = true;
            this.$get('OrderLogisticsSpeed/' + item.uuid , {})
                .then(data => {
                    this.loading = false;
                    this.addressData = data;
                    this.mapTrackVisible = true;
                } , error => {
                    this.loading = false;
                    this.$$message.error(error);
                });
        },
         //处理结果
       resultsTreatment(item){
           this.loading = true;
           this.$get('OrderExceptional/' + item.uuid)
            .then(data => {
                this.loading = false;
                this.abnormalResultData = data;
                this.abnormalResultVisible = true;
            } , error => {
                this.loading = false;
                this.$message.error(error);
            });
       },
       tabChange(id){
           this.tabId = id;
           this.pageNumber = 1;
            this.pageNumberInput = 1;
            this.getOrderList();
       },
        //    选择司机
        selectDriver(item){
            this.selectItem = item;
            this.driverVisible = true;
        },

        //    切换页码
        handleCurrentChange(val){
            this.pageNumber = val;
            this.pageNumberInput = val;
            this.getOrderList();
        },
        // 手动输入页码后确定
        changeNumberInput(){
            if(parseInt(this.pageNumberInput) > this.lastPage){
                this.$message.error('当前页码大于总页码！');
                return
            }
            this.pageNumber = parseInt(this.pageNumberInput);
            this.getOrderList();
        },
        getOrderList(uuid){
            let params = {
                page_index:this.pageNumber,
                page_size:this.pageSize,
                type:1,
                status:this.tabId,
                uuid:uuid
            }
            this.addressList = [];
            this.loading = true;
            this.$get('Order',params)
                .then(data => {
                    this.orderList = data.data;
                    this.total = data.total;
                    this.lastPage = data.last_page;
                    this.loading = false;
                } , error => {
                    this.loading = false;
                    this.$message.error(error);
                });
        },
        // 联系司机
        getPhone(item){
            this.phoneItem = {
               title:'联系方式',
               phone:item.driver_phone
           };
            this.phoneVisible = true;
        },
        // 联系客服
        getCustomerPhone(){
             this.phoneItem = {
               title:'客服联系方式',
               phone:this.customer.phone
           };
            this.phoneVisible = true;
        },
        goDetails(item){
            this.$router.push({path:'/orderDetails',query:{orderId:item.uuid}});
        }
   },
   created() {

       this.getOrderList(this.$route.query.orderId);
   },
   mounted() {

   }
}
</script>

<style scoped lang='less'>
.order_list{
    background:#fff;
    &_item{
        padding: 20px 60px 20px 20px;
        font-size: 16px;
        border-bottom:1px solid #E1E1E1;
        cursor: pointer;
        &_header{
            display: flex;
            justify-content: space-between;
        }
        &_content{
            margin-top:16px;
            display: flex;
            justify-content: space-between;
            &_left{
                display: flex;
                &_city{
                    display: inline-block;
                    width:112px;
                    font-size: 28px;
                    font-weight: 600;
                    line-height: 40px;
                    white-space:nowrap;//不换行
                    overflow: hidden;//超出隐藏
                    text-overflow: ellipsis;//变成...
                }
                &_title{
                    position: relative;
                    width:85px;
                    margin-left:10px ;
                    img{
                        width: 65px;
                        position: absolute;
                        top:10px;
                        left:10px;
                    }
                    div{
                        font-size: 14px;
                        position: relative;
                        left:-6px;
                        top:-2px;
                        text-align: center;
                    }
                }
            }
            &_right{
                display: flex;
                /deep/ .el-button{
                    font-size: 16px;
                    font-weight: 400;
                    padding:11px 19px;
                    border:1px solid #409EFF;
                    color:#1F9EFF;
                }
                /deep/ .el-button.el-button--primary{
                    color:#fff;
                }
                /deep/ .el-button.el-button--primary:hover{
                    border-color:#66b1ff;
                    background:#66b1ff;
                }
                /deep/ .el-button--default{
                    border-color:#1F9EFF;
                    color:#1F9EFF;
                }
            }
        }
    }
    &_pagination{
        padding-top:30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color:#000000;
        /deep/ .el-pager li,/deep/ .btn-next, /deep/ .btn-prev{
            min-width: 36px;
            height: 36px;
            padding-top:4px;
            margin: 0 4px;
        }
        /deep/ .btn-prev{
            margin-left: 0;
        }
        &_right{
            display: flex;
            align-items: baseline;
            &_num{
                span{
                    color:#3D7FFF;
                }

            }
            &_input{
                margin:0 10px;
            }
            &_btn{
                /deep/ .el-button{
                    background:#F0F2F5;
                    height: 36px;
                    border:1px solid #D7DBE0;
                    font-size: 14px;
                    color:#333;
                }
                /deep/ .el-button:hover{
                    color: #409EFF;
                    border-color: #c6e2ff;
                    background-color: #ecf5ff;
                }

            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderList/orderList.vue